/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type RevokePlannerAccountThirdpartyOAuthCredentialsInput = {
  provider: OAuthProvider;
};

export type StoreGoogleOAuthCredentialForPlannerAccountMutationVariables = Exact<{
  code: string;
  redirectUri: string;
}>;


export type StoreGoogleOAuthCredentialForPlannerAccountMutation = { storePlannerAccountOAuthCredential: { __typename: 'StorePlannerAccountOAuthCredentialSuccessPayload' } };

export type RevokeGoogleOAuthTokenForPlannerAccountMutationVariables = Exact<{
  input: Types.RevokePlannerAccountThirdpartyOAuthCredentialsInput;
}>;


export type RevokeGoogleOAuthTokenForPlannerAccountMutation = { revokePlannerAccountThirdpartyOAuthCredentials: { __typename: 'RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload' } };


export const StoreGoogleOAuthCredentialForPlannerAccountDocument = gql`
    mutation storeGoogleOAuthCredentialForPlannerAccount($code: String!, $redirectUri: String!) {
  storePlannerAccountOAuthCredential(
    input: {provider: GOOGLE, code: $code, redirectUri: $redirectUri}
  ) {
    __typename
  }
}
    `;

/**
 * __useStoreGoogleOAuthCredentialForPlannerAccountMutation__
 *
 * To run a mutation, you first call `useStoreGoogleOAuthCredentialForPlannerAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStoreGoogleOAuthCredentialForPlannerAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStoreGoogleOAuthCredentialForPlannerAccountMutation({
 *   variables: {
 *     code: // value for 'code'
 *     redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useStoreGoogleOAuthCredentialForPlannerAccountMutation(options: VueApolloComposable.UseMutationOptions<StoreGoogleOAuthCredentialForPlannerAccountMutation, StoreGoogleOAuthCredentialForPlannerAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StoreGoogleOAuthCredentialForPlannerAccountMutation, StoreGoogleOAuthCredentialForPlannerAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StoreGoogleOAuthCredentialForPlannerAccountMutation, StoreGoogleOAuthCredentialForPlannerAccountMutationVariables>(StoreGoogleOAuthCredentialForPlannerAccountDocument, options);
}
export type StoreGoogleOAuthCredentialForPlannerAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StoreGoogleOAuthCredentialForPlannerAccountMutation, StoreGoogleOAuthCredentialForPlannerAccountMutationVariables>;
export const RevokeGoogleOAuthTokenForPlannerAccountDocument = gql`
    mutation revokeGoogleOAuthTokenForPlannerAccount($input: RevokePlannerAccountThirdpartyOAuthCredentialsInput!) {
  revokePlannerAccountThirdpartyOAuthCredentials(input: $input) {
    __typename
  }
}
    `;

/**
 * __useRevokeGoogleOAuthTokenForPlannerAccountMutation__
 *
 * To run a mutation, you first call `useRevokeGoogleOAuthTokenForPlannerAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeGoogleOAuthTokenForPlannerAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeGoogleOAuthTokenForPlannerAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRevokeGoogleOAuthTokenForPlannerAccountMutation(options: VueApolloComposable.UseMutationOptions<RevokeGoogleOAuthTokenForPlannerAccountMutation, RevokeGoogleOAuthTokenForPlannerAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RevokeGoogleOAuthTokenForPlannerAccountMutation, RevokeGoogleOAuthTokenForPlannerAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RevokeGoogleOAuthTokenForPlannerAccountMutation, RevokeGoogleOAuthTokenForPlannerAccountMutationVariables>(RevokeGoogleOAuthTokenForPlannerAccountDocument, options);
}
export type RevokeGoogleOAuthTokenForPlannerAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RevokeGoogleOAuthTokenForPlannerAccountMutation, RevokeGoogleOAuthTokenForPlannerAccountMutationVariables>;